import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { ValidatorService } from 'src/app/components/shared/sharedModules/validator/validator.service';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { AuthRegisterActions } from '../../auth-register.actions.enum';

@Component({
  selector: 'app-auth-register-create-form',
  templateUrl: './auth-register-create-form.component.html',
  styleUrls: ['./auth-register-create-form.component.sass'],
})
export class AuthRegisterCreateFormComponent implements OnInit {
  @Input() formData: UntypedFormGroup;
  @Input() countriesList: SelectItem[];
  @Input() showLoginLoading: boolean;
  @Input() actionList: Actions<AuthRegisterActions, any>;
  @Input() sendSmsAction: AuthRegisterActions;
  @Input() changeCountryAction: AuthRegisterActions;

  constructor(public changeDetectorRef: ChangeDetectorRef, public validatorService: ValidatorService) {
    /** */
  }

  ngOnInit(): void {
    /** */
  }

  /**
   *  method to send sms code
   */
  sendSms(): void {
    this.actionList?.emit(AuthRegisterActions.SEND_SMS, null);
  }

  /**
   * change country
   */
  changeCountry(): void {
    this.actionList.emit(AuthRegisterActions.CHANGE_COUNTRY, null);
  }
}
